<template>
  <div>
    <nav-top Title="登录LULUTV">
      <template #right>
        <div @click="$router.push(path)">返回</div>
      </template>
    </nav-top>
    <field-text
        label="用户名/邮箱"
        style="margin: 15px 0;"
        placeholder="请输入用户名/邮箱"
        ref="user"
        @contentWatch="res => model.username = res"
    >
    </field-text>
    <field-text
        label="密码"
        style="margin: 15px 0;"
        placeholder="请输入密码"
        type="password"
        ref="password"
        showButton=true
        buttonMsg="忘记密码"
        @handeClick="$router.push('/findPWD')"
        @contentWatch="res => model.pwd = res"
    >
    </field-text>
    <verify-code
        ref="verify"
        @captchaWatch="res => model.captcha = res"
        @captchaToken="res => model.captchaToken = res"
    >
    </verify-code>
    <login-btn
        msg="登录"
        msg2="注册"
        @login="login"
        @register="$router.push('/register')"
    >
    </login-btn>
  </div>
</template>

<script>
import NavTop from "@/components/common/NavTop";
import FieldText from "@/components/common/FieldText";
import VerifyCode from "@/components/common/VerifyCode";
import LoginBtn from "@/components/common/LoginBtn";
import { initializeEncryption, rsaEncrypt } from "@/utils/rsaEncrypt";
import { showLoadingToast, showFailToast } from 'vant';
import { getUserInfo } from "@/utils/http";
import {handleError} from '@/utils/ecode';

export default {
  data() {
    return {
      model: {},
    };
  },
  props: ["path"],
  async created() {
    await initializeEncryption();
  },
  name: "loginPage",
  components: {
    NavTop,
    FieldText,
    VerifyCode,
    LoginBtn,
  },
  methods: {
    async login() {
      if (!this.validateForm()) {
        return;
      }

      let data = {
        'token': this.model.captchaToken,
        'code': this.model.captcha,
        'userid': this.model.username,
        'appid': 1,
        'pwd': rsaEncrypt(this.model.pwd)
      };

      let toast = showLoadingToast({
        message: '登陆中...',
        forbidClick: true,
      });

      try {
        const res = await this.$user_http.post("/user/login", data);
        if (res.data.code === 0) {
          const token = res.data.data.token;
          const refreshToken = res.data.data.refresh;
          const expiry = new Date().getTime() + 3600 * 1000 * 24 * 7// 假设 token 有效期为1小时
          this.$store.commit('setToken', {token:token, refreshToken:refreshToken, expiry:expiry})
          const code = await getUserInfo();
          if (code === 0) {
            toast.close();
            let path = sessionStorage.getItem('redirectPath') || '/';
            sessionStorage.removeItem('redirectPath');
            this.$router.push(path);
            return;
          }
        } else {
          handleError(res.data.code, this.$refs.verify);
        }
      } catch (error) {
        showFailToast("网络链接失败!请检查网络！或稍后再试");
        console.error('Error fetching data:', error);
      }
    },

    validateForm() {
      const captchaRegex = /^[a-zA-Z0-9]{4,5}$/;

      if (!this.model.username) {
        this.setError(this.$refs.user, "用户名不能为空");
        return false;
      }
      if (!this.model.pwd) {
        this.setError(this.$refs.password, "密码不能为空");
        return false;
      }
      if (!captchaRegex.test(this.model.captcha)) {
        this.setError(this.$refs.verify, "验证码不正确");
        return false;
      }

      return true;
    },

    setError(ref, errMsg) {
      ref.err = true;
      ref.content = "";
      ref.errMsg = errMsg;
    },
  },
};
</script>

<style scoped>
</style>
